import dynamic from "next/dynamic";
import {GmcItemEditorProps} from "./GmcItemEditor";

export const GmcItemEditor = dynamic<GmcItemEditorProps>(() =>
  import('./GmcItemEditor').then((module) => module.GmcItemEditor),
);
